import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2.ts';
import { BANNER_ADS_AB_TEST } from '../constants.ts';

export const isBannerAdsAbTestVariant = (getAbTestFn = getAbTestV2): boolean => {
    return getAbTestFn(BANNER_ADS_AB_TEST)?.variant === 'variant';
};

export const trackBannerAdsAbTestVariant = (): void => trackAbTestV2Variant(BANNER_ADS_AB_TEST);
